export default __webpack_public_path__ + "static/agency-lead-e3aa30e0a04666d14a53d1254ab5a191.png";